@if (homepageQuicklinks) {
  <ul class="list-group list-group-flush">
    @for (quickLink of quicklinks; track quickLink) {
      <li
        class="list-group-item bg-transparent ps-0 py-1"
        >
        <a
          href="#"
          class="text-decoration-none"
          [ngClass]="quickLinkClass"
          (click)="gotoLink(quickLink, $event)"
          >
          {{ quickLink.language_definitions[0].quicklink_text }}
        </a>
      </li>
    }
  </ul>
} @else {
  <div  [@pageAnimations]>
    <ul class="list-group list-group-flush navbar-quicklinks ani-item">
      @for (quickLink of quicklinks; track quickLink) {
        <li
          class="list-group-item bg-transparent ps-0 py-0"
          (click)="gotoLink(quickLink, $event)"
          >
          <a
            href="#"
            class="text-decoration-none"
            [ngClass]="quickLinkClass"
            (click)="gotoLink(quickLink, $event)"
            >
            {{ quickLink.language_definitions[0].quicklink_text }}
          </a>
        </li>
      }
    </ul>
  </div>
}

